(function () {
  "use strict";

  GenericServerActionCtrl.$inject = ['$scope', '$timeout'];
  angular
    .module('trainerWebApp.modals')
    .controller('GenericServerActionCtrl', GenericServerActionCtrl);

  function GenericServerActionCtrl($scope, $timeout) {

    $scope.modal = {
      content: 0,
      options: {
        title: 'Warning',
        warningText: '',
        executingText: '',
        okButtonId: '',
        cancelButtonId: '',
        confirmEventName: 'genericServerActionEvent'
      },
      status: ''
    };

    $scope.execute = function () {
      $scope.modal.status = 'executing';
      $scope.$emit($scope.modal.options.confirmEventName, function () {
        $scope.dismiss();
        $timeout(function () {
          $scope.modal.status = ''
        }, 500);
      });
    };

    $scope.$on('genericServerActionShow', function (event, options) {
      $scope.modal.status = '';
      $scope.modal.options = options;
    });
  }

})();
